import classNames from 'classnames'
import React from 'react'
import { Column, Grid } from 'src/components/framework/ui'
import { SecurityImage } from 'src/components/framework/ui/security-image'
import { usePageContext } from 'src/contexts/page.context'
import { useSecurityContext } from 'src/contexts/security.context'
import {
  LOSING_STYLES,
  SecurityStyle,
  WINNING_STYLES,
} from 'src/shared/security.dto'

import { SecurityQuoteContainer } from './security-quote.container'

export const SecurityDetails: React.FC = () => {
  const { reportName } = usePageContext()
  const { security } = useSecurityContext()

  return (
    <Grid>
      <Column shrink={'shrink'} className={'stk-hide-msm'}>
        <SecurityImage security={security} width={60} height={60} />
      </Column>
      <Column>
        <h1
          className={'stk-text-h2'}
          aria-label={`${security.ticker} - ${security.name} share price`}
        >
          <span className={'stk-text-unimportant'}>
            {security.ticker} &mdash;
          </span>
          &nbsp;{security.name}&nbsp;
          <span className="stk-text-small stk-text-unimportant">
            {reportName}
          </span>
        </h1>
        <SecurityQuoteContainer />
        <div role="list">
          {security.sectors.length > 0 ? (
            <span
              className={'stk-text-keyword'}
              aria-label={`Sector: ${security.sectors[0].name}`}
              role="listitem"
            >
              {security.sectors[0].name}
            </span>
          ) : null}
          <span className={'stk-text-separator'} />
          <span
            className={'stk-text-keyword'}
            aria-label={`Risk rating: ${security.ratios.general.riskRating}`}
            role="listitem"
          >
            {security.ratios.general.riskRating}
          </span>
          <span className={'stk-text-separator'} />
          <span
            className={'stk-text-keyword'}
            aria-label={`Market cap: ${security.ratios.general.size}`}
            role="listitem"
          >
            {security.ratios.general.size}
          </span>
          <span className={'stk-text-separator'} />
          <span
            className={classNames(
              'stk-text-keyword ',
              getSecurityStyleClass(security.ratios.general.style),
            )}
            aria-label={`Classification: ${security.ratios.general.style}`}
            role="listitem"
          >
            {security.ratios.general.style}
          </span>
        </div>
      </Column>
    </Grid>
  )
}

function getSecurityStyleClass(style: SecurityStyle): string {
  let className = ''

  if (WINNING_STYLES.includes(style)) {
    className = 'stk-text-success'
  } else if (LOSING_STYLES.includes(style)) {
    className = 'stk-text-danger'
  }

  return className
}
